<a appTooltip="Attività da completare" placement="bottom" [attr.aria-label]="getAriaLabel()" [appTooltipEnabled]="true" class="dropdown-toggle"
	data-toggle="dropdown" (click)="onClick.emit($event)" href="#" role="button" aria-haspopup="true"
	aria-expanded="false">
	{{attivitaTotali}}
</a>
<div class="dropdown-menu">
	<h2>Attivit&agrave; da completare</h2>

	<div *ngIf="attivitaCompletareList.length > 0" class="alert_content">
		<ul attivita-completare-list class="att_completare" [attivitaList]="attivitaCompletareList" [slice]="numToView">
		</ul>
		<small class="sr-only">
			Sono presenti {{attivitaTotali}} attivit&agrave; da completare
		</small>
	</div>
	<div *ngIf="attivitaCompletareList.length == 0">
		<p class="allinea_centro">Non ci sono attivit&agrave; da completare</p>
		<small class="sr-only">
			Non ci sono attività da completare
		</small>
	</div>
	<div class="read_more">
		<a appTooltip="Vedi tutte le attività da completare" [appTooltipEnabled]="true"
			aria-label="Vedi tutti gli adempimenti inevasi" [routerLink]="['/',viewAllAttivitaCompletare]">
			Vedi tutti
		</a>
	</div>
</div>